module.exports = __webpack_public_path__ + "static/media/sass.f850de41.png";